import * as KendoButton from '@progress/kendo-react-buttons'
import pipe from 'lodash/fp/pipe'
import * as React from 'react'
import {connect} from 'react-redux'
import * as Router from '../../router'

export const preventDefaultThen = (fn: any) => pipe(
  (e: React.SyntheticEvent) => e.preventDefault(),
  fn,
)

export const stopPropagationThen = (fn: any) => pipe(
  (e: React.SyntheticEvent) => e.stopPropagation(),
  fn,
)

export const preventDefault = () => (e: React.SyntheticEvent) => e.preventDefault()

interface ComponentProps {
  children: any,
  href: string,
}
interface DispatchProps {push: (href: string) => Router.PushAction}
type Props = ComponentProps & DispatchProps & KendoButton.ButtonProps
export const Link = connect(
  null,
  {push: Router.push},
)(({href, push, children, ...props}: Props) =>
<KendoButton.Button {...props} onClick={preventDefaultThen(() => push(href))}>
  {children}
</KendoButton.Button>)

type AnchorLinkProps = ComponentProps & DispatchProps & React.HTMLProps<HTMLAnchorElement>
export const AnchorLink = connect(
  null,
  {push: Router.push},
)(({href, push, children, ...props}: AnchorLinkProps) =>
<a {...props} href={href} onClick={preventDefaultThen(() => push(href))}>
  {children}
</a>)



// WEBPACK FOOTER //
// ./src/components/link/component.tsx